import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MainHeaderNavbarMobileComponentGeneric } from "./navbar-mobile.component";
import { MainHeaderNavbarMobileTopModuleGeneric } from "./top/navbar-mobile-top.module";
import { MainHeaderNavbarMobileSideModuleGeneric } from "./side/navbar-mobile-side.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MainHeaderNavbarMobileTopModuleGeneric,
        MainHeaderNavbarMobileSideModuleGeneric
    ],
    declarations: [MainHeaderNavbarMobileComponentGeneric],
    exports: [MainHeaderNavbarMobileComponentGeneric]
})
export class MainHeaderNavbarMobileModuleGeneric {}
